import type { VAxios } from '../../define/axios/Axios';

export type TortFeedbackStatus = 'pending' | 'approved' | 'rejected' | 'cancelled';

export type TortFeedbackType = 'copyright' | 'trademark' | 'other';

export interface TortFeedbackGoodsImage {
  imageId: string;
  imageUrl: string;
}

export interface TortFeedbackGoodsItem {
  goodsId: string;
  sku: string;
  images: TortFeedbackGoodsImage[];
  prints: TortFeedbackGoodsImage[];
}

export interface TortFeedbackSubmitParams {
  goodsId?: string;
  sku?: string;
  imageUrl: string;
  imageId?: string;
  caseNo?: string;
  caseLink?: string;
  tortTypes: TortFeedbackType[];
  description: string;
  proofFiles?: string[];
}

export interface TortFeedbackVO {
  id: string;
  userId?: string;
  userName?: string;
  goodsId?: string;
  sku?: string;
  imageUrl: string;
  imageId?: string;
  caseNo?: string;
  caseLink?: string;
  tortTypes: TortFeedbackType[];
  description: string;
  proofFiles?: string[];
  status: TortFeedbackStatus;
  statusText: string;
  rejectReason?: string | null;
  rewardAmount?: number | null;
  createTime: string;
  updateTime?: string | null;
  reviewTime?: string | null;
}

export interface TortFeedbackMineParams {
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortOrder?: 'ascend' | 'descend';
  status?: TortFeedbackStatus;
  userId?: string;
  startCreateTime?: string;
  endCreateTime?: string;
}

export interface TortFeedbackPageResult {
  total: number;
  pages: number;
  items: TortFeedbackVO[];
}

/**
 * 侵权反馈相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  getGoodsBySku(params: { sku: string }) {
    return defHttp.get<TortFeedbackGoodsItem[]>({
      url: `/aiad/tort-feedback/goods`,
      params,
    });
  },

  submit(params: TortFeedbackSubmitParams) {
    return defHttp.post<string>({
      url: `/aiad/tort-feedback`,
      params,
    });
  },

  getMine(params?: TortFeedbackMineParams) {
    return defHttp.get<TortFeedbackPageResult>({
      url: `/aiad/tort-feedback/mine`,
      params,
    });
  },

  getDetail(id: string) {
    return defHttp.get<TortFeedbackVO>({
      url: `/aiad/tort-feedback/${id}`,
    });
  },

  update(id: string, params: TortFeedbackSubmitParams) {
    return defHttp.put<null>({
      url: `/aiad/tort-feedback/${id}`,
      params,
    });
  },

  cancel(id: string) {
    return defHttp.put<null>({
      url: `/aiad/tort-feedback/${id}/cancel`,
    });
  },
});
